import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=34808c8d"
import script from "./CalendarCard.vue?vue&type=script&lang=js"
export * from "./CalendarCard.vue?vue&type=script&lang=js"
import style0 from "./CalendarCard.vue?vue&type=style&index=0&id=34808c8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports